import cn from 'classnames';
import { useEffect } from 'react';
// Types
import { PaymentCardsProps } from 'helpers/payments.types';
// Components
import { Card } from './Card/Card';
// Styles
import styles from './PaymentCards.module.scss';

const PaymentCards = ({
  data,
  onPaymentSelect,
  layout = 'grid',
}: PaymentCardsProps) => {
  useEffect(() => {
    if (data?.length) {
      const defaultPaymentMethodId =
        data?.find((i) => i?.isDefault)?.methodId || '';

      if (onPaymentSelect) {
        onPaymentSelect(defaultPaymentMethodId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <ul
      className={cn(styles.paymentCardsWrapper, {
        [styles.stacked]: layout === 'stacked',
      })}
    >
      {data?.map((payment, index) => (
        <li key={payment.id} className={styles.paymentCardItem}>
          <Card payment={payment} index={index} onSelect={onPaymentSelect} />
        </li>
      ))}
    </ul>
  );
};

export default PaymentCards;
